import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';

/**
 * `/app/conversation` belongs to the legacy V1 shell.  A stale/default app
 * link can still reach it after the mobile V2 (`layoutUI=app`) shell loads.
 * A query-less link is also a legacy V2 app link. V1 is the only caller that
 * may remain on this path and must identify itself with `layoutUI=v1`.
 */
@Injectable({providedIn: 'root'})
export class LegacyAppConversationRedirectGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const layoutUI = route.queryParamMap.get('layoutUI');
    if (layoutUI === 'v1') {
      return true;
    }

    const source = this.router.parseUrl(state.url);
    return this.router.createUrlTree(['/conversation'], {
      queryParams: source.queryParams,
      fragment: source.fragment || undefined,
    });
  }
}
